import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'
import FileSelector from '@src/components/inputs/FileSelector'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import LoadingIcon from '@src/components/icon/LoadingIcon'
import SVGLoader from '@src/components/svg/SVGLoader'

const BannerForm = () => {
	const { getBannerFormProps } = useMyProductFormContext()
	const {
		bannerFileTag,
		loadingBannerFile,
		bannerBase64,
		selectBannerFile,
		removeBanner,
		errorMsg,
	} = getBannerFormProps()

	return (
		<div>
			<SelectorWrapper>
				<FileSelector
					ref={bannerFileTag}
					label="대표 이미지"
					buttonTxt="이미지 추가"
					onChange={selectBannerFile}
					wrapperStyle={css`
						padding: 0;
						flex-direction: column;
					`}
					uploadBtnStyle={css`
						background: #ffcf19;
						border-radius: 4px;
						font-weight: 600;
						font-size: 1.4rem;
						line-height: 1.7rem;
						letter-spacing: 0.2px;
						color: #000000;
						width: auto;
						height: auto;
						padding: 1rem;
					`}
					errorMsg={errorMsg}
				/>
				{loadingBannerFile && (
					<LoadingIconWrapper>
						<LoadingIcon width={20} height={20} />
					</LoadingIconWrapper>
				)}
			</SelectorWrapper>
			{bannerBase64 && (
				<BannerWrapper>
					<CancelIconWrapper
						onClick={() => {
							if (removeBanner) removeBanner()
						}}
					>
						<SVGLoader name="closeIcon" />
					</CancelIconWrapper>
					<BannerImg src={bannerBase64} alt="상품 배너 이미지" />
				</BannerWrapper>
			)}
		</div>
	)
}
const SelectorWrapper = styled.div`
	display: inline-block;
	position: relative;
`
const LoadingIconWrapper = styled.div`
	position: absolute;
	top: 34px;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
	background: #00000066;

	display: flex;
	align-items: center;
	justify-content: center;
`
const BannerWrapper = styled.div`
	position: relative;
	width: 30rem;
`
const BannerImg = styled.img`
	max-width: 100%;
	width: 100%;
`

const CancelIconWrapper = styled.button`
	position: absolute;
	top: 1rem;
	right: 1rem;
	color: #7f7f7f;
	width: 1.8rem;
	height: 1.8rem;
	border-radius: 100%;
	background: #eaeaea;
	padding: 0.6rem;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
`
export default BannerForm
